import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { isLoggedIn } from "../../util";

import IconPicker from '../commonViews/IconPicker.jsx'
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import DatePicker from "react-datepicker";

import HersheysCompetitionAudits from "./HersheysCompetitionAudits.jsx";
import {
  fetchHersheysCompetitionTemplatesAction,
  downloadHersheysCompetitionReportAction,
  getAuditReports
} from "../../actions/hersheys_competition_actions";
import { Grid } from "semantic-ui-react";
import TableView from "../commonViews/TableView";
import {
  getTextColor,
  getMainBackground,
  getMatchingTint,
  getFontColor,
} from "../../ThemeHandlers/theme";
import ConstantLabel from "../commonViews/ConstantLabel";
import ModalView from "../commonViews/ModalView";
class HersheysCompetition extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      hersheysCompetitionfromDate: new Date(),
      hersheysCompetitiontoDate: new Date(),
      firstDateChoose: null,
      hersheysCompetitionSelectedTemplate: {},
      selectedTemplateData: "",
      thisTemplatesView: true,
      thisReportDownloading: false,
      modalOpen: false,
      template: {},
      email: "",
      count: "",
      templates: [],
      matTableLoad: false,
      color: "",
    };
  }

  componentDidMount() {
    if (!isLoggedIn(this.props.auth)) {
      this.props.history.push(`/login`);
      return;
    }
    if (this.props.auth.color) {
      this.setState({ color: this.props.auth.color });
    }
    this.setState({ matTableLoad: true });
    this.props.fetchHersheysCompetitionTemplates({
      onSuccess: () => {
        this.setState({ matTableLoad: false });
      },
      onFailure: () => {
        this.setState({ matTableLoad: false });
      },
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.auth.color !== prevProps.auth.color) {
      this.setState({ color: this.props.auth.color });
    }
    if (this.props.hersheysCompetition.templates !== prevProps.hersheysCompetition.templates) {
      this.setState({
        templates: this.props.hersheysCompetition.templates,
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ thisReportDownloading: false });
  }

  searchFilter = (filter, row) => {
    var flatData = JSON.stringify(row._original);
    return flatData.toLowerCase().includes(filter.value.toLowerCase());
  };

  handleCloseClick = () => {
    this.setState({ thisTemplatesView: true });
  };

  handleTableViewAuditClick = (template) => {
    if (!template._id) return;
    this.setState({
      hersheysCompetitionSelectedTemplate: template,
      thisTemplatesView: false,
    });
  };

  downloadReport = (template) => {
    this.setState({ thisReportDownloading: true, matTableLoad: true });
    this.props.downloadHersheysCompetitionReportAction({
      templateId: template._id,
      onSuccess: () => {
        this.setState({ matTableLoad: false });
      },
      onFailure: () => {
        this.setState({ matTableLoad: false });
      },
    });
  };
  downloadPDFReport = (template) => {
    this.setState({ modalOpen: true, selectedTemplateData: template._id });
  };
  hersheysCompetitioncloseEditUser = () => {
    this.setState({ modalOpen: false });
  };




  render() {
    var templates =
      this.state.templates.length !== 0 ? this.state.templates : [];

    var col = [
      {
        title: "Template Name",
        field: "auditName",
        render: (rowData) => {
          return (
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                this.handleTableViewAuditClick(rowData);
              }}
            >
              {rowData.auditName}
            </span>
          );
        },
      }
    ];

    return (
      <div style={{ flexGrow: 1, display: "flex", flexFlow: "column" }}>
        <NotificationContainer />
        {this.state.thisTemplatesView && (
          <div>
            <h1 style={{ color: getTextColor(this.state.color) }}>Templates</h1>

            <TableView
              columns={col}
              data={templates}
              selection={false}
              load={this.state.matTableLoad}
            />
          </div>
        )}
        {!this.state.thisTemplatesView && (
          <HersheysCompetitionAudits
            selectedTemplate={this.state.hersheysCompetitionSelectedTemplate}
            onClose={this.handleCloseClick}
            color={this.state.color}
          />
        )}
        <ModalView
          open={this.state.modalOpen}
          close={this.hersheysCompetitioncloseEditUser}
          size={"small"}
          content={
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column >
                  <ConstantLabel
                    title={"Date"}
                    size={"large"}
                    styles={{
                      backgroundColor: getMainBackground(this.props.color),
                      color: getFontColor(this.props.color),
                    }}
                  />

                  <div style={{ display: "inline-block", marginLeft: 10 }}>
                    <DatePicker
                      selected={this.state.hersheysCompetitionfromDate}
                      onChange={this.handleFromDate}
                      placeholderText="Choose From Date"
                      style={{ marginRight: -20 }}

                    />
                  </div>
                </Grid.Column>

                <Grid.Column >

                  <ConstantLabel
                    title={"Email"}
                    size={"large"}
                    styles={{
                      backgroundColor: getMainBackground(this.props.color),
                      color: getFontColor(this.props.color),
                    }}
                  />
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    value={this.state.email}
                    style={{ borderRadius: 5, marginLeft: 10, height: 30 }}
                    onChange={this.handleEmail}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          }
          showSave={true}
          saveClick={this.hersheysCompetitiondownloadPdfsReports}
          saveText={'Mail Reports'}
        />

      </div>
    );
  }
}

function AuditTableCell(props) {
  function onClick() {
    props.onClick(props.row);
  }
  return (
    <div style={props.style} onClick={onClick}>
      {props.text}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    hersheysCompetition: state.hersheysCompetition,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchHersheysCompetitionTemplates: fetchHersheysCompetitionTemplatesAction,
      downloadHersheysCompetitionReportAction: downloadHersheysCompetitionReportAction,
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HersheysCompetition)
);
